import { jsx as a } from "react/jsx-runtime";
import m from "react";
import "./usePageLifecycle.consts.mjs";
import { getFileExtension as e } from "./file.mjs";
import "./getCentsSeparatorByCurrencyCode.mjs";
import "./getCurrencyCodeBySymbol.mjs";
import "./getCurrencyCodeFromString.mjs";
import "./getCurrencyCodeRTL.mjs";
import "./getCurrencySymbolByCode.mjs";
import "./getCurrencySymbolPlaceByCode.mjs";
import "./getCurrencySymbolSeparatorByCode.mjs";
import "big.js";
import "./getSeparatorByCurrencyCode.mjs";
import "./stringToBigFormat.mjs";
import "./moneyUtils.consts.mjs";
import { S as n } from "./no-preview-D-KUNa8H.js";
import { EFileExtension as o } from "./attachment.mjs";
import { S, a as r, b as v, c as g, d as p, e as P, f as l, g as f, h as E, i as c, j as x, k as C, l as I, m as N, n as D, o as F, p as T, q as d, r as A, s as M, t as _ } from "./zip-CO1gAMlh.js";
const L = {
  [o.EPS]: S,
  [o.PNG]: r,
  [o.AVI]: v,
  [o.JPG]: g,
  [o.DOC]: p,
  [o.XLS]: P,
  [o.CAD]: l,
  [o.CSS]: f,
  [o.DLL]: E,
  [o.HTML]: c,
  [o.JS]: x,
  [o.MOV]: C,
  [o.MP3]: I,
  [o.PDF]: N,
  [o.PHP]: D,
  [o.PPT]: F,
  [o.PSD]: T,
  [o.RAR]: d,
  [o.TXT]: A,
  [o.WAV]: M,
  [o.ZIP]: _
}, O = (s) => {
  const i = "fileExtension" in s ? s.fileExtension : e(s.fileName);
  if (!i)
    return null;
  const t = L[i];
  return t !== void 0 ? /* @__PURE__ */ a(t, {}) : /* @__PURE__ */ a(n, { className: s.noPreviewClassName });
}, K = m.memo(O);
export {
  K as F
};
//# sourceMappingURL=FileExtensionIcon-BjXIuwJw.js.map
